import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiBadge from "components/SuiBadge";
import { projectStatusOptions } from "utils/data";

const ProjectStatusTag = ({ status }) => {
  const option = projectStatusOptions.find((x) => x.value == status) || {};
  const bageLabel = (
    <SuiBox sx={{ fontSize: 12, px: 0.5, py: 0.5 }} fontWeight="bold" color="inherit">
      {option?.label}
    </SuiBox>
  );

  if (option) {
    if (option.value == "init") {
      return <SuiBadge color="warning" variant="contained" size="xs" badgeContent={bageLabel} />;
    } else if (option.value == "requested") {
      return <SuiBadge color="info" variant="contained" size="xs" badgeContent={bageLabel} />;
    } else if (option.value == "active") {
      return <SuiBadge color="success" variant="contained" size="xs" badgeContent={bageLabel} />;
    } else if (option.value == "canceled") {
      return <SuiBadge color="error" variant="contained" size="xs" badgeContent={bageLabel} />;
    } else if (option.value == "completed") {
      return <SuiBadge color="dark" variant="contained" size="xs" badgeContent={bageLabel} />;
    } else {
      return <SuiBadge color="secondary" variant="contained" size="xs" badgeContent={bageLabel} />;
    }
  } else {
    return bageLabel;
  }
};

export default ProjectStatusTag;
